var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMiniDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_11637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46875 17.3109V1.68984L2.46406 1.6875H11.0625V5.59219C11.0625 6.45469 11.7641 7.15625 12.6266 7.15625H16.5258C16.5266 7.16875 16.5313 7.18516 16.5313 7.19688L16.5375 17.3125L2.46875 17.3109ZM15.4977 5.59375L12.625 5.59219V2.47188L15.4977 5.59375ZM17.3547 5.30391L13.3539 0.95625C12.9109 0.475 12.1188 0.125 11.4695 0.125H2.46406C2.05013 0.126448 1.65367 0.292004 1.36164 0.585357C1.0696 0.87871 0.905835 1.27591 0.906251 1.68984V17.3109C0.905834 17.7245 1.06941 18.1214 1.36113 18.4146C1.65285 18.7078 2.04891 18.8733 2.4625 18.875H16.5375C16.9514 18.8733 17.3477 18.7076 17.6394 18.414C17.9312 18.1205 18.0946 17.7232 18.0938 17.3094V7.19688C18.0938 6.56563 17.7828 5.76953 17.3547 5.30391Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 9.5H6.375C6.1678 9.5 5.96909 9.58231 5.82257 9.72882C5.67606 9.87534 5.59375 10.074 5.59375 10.2812C5.59375 10.4885 5.67606 10.6872 5.82257 10.8337C5.96909 10.9802 6.1678 11.0625 6.375 11.0625H12.625C12.8322 11.0625 13.0309 10.9802 13.1774 10.8337C13.3239 10.6872 13.4062 10.4885 13.4062 10.2812C13.4062 10.074 13.3239 9.87534 13.1774 9.72882C13.0309 9.58231 12.8322 9.5 12.625 9.5ZM12.625 13.4062H6.375C6.1678 13.4062 5.96909 13.4886 5.82257 13.6351C5.67606 13.7816 5.59375 13.9803 5.59375 14.1875C5.59375 14.3947 5.67606 14.5934 5.82257 14.7399C5.96909 14.8864 6.1678 14.9688 6.375 14.9688H12.625C12.8322 14.9688 13.0309 14.8864 13.1774 14.7399C13.3239 14.5934 13.4062 14.3947 13.4062 14.1875C13.4062 13.9803 13.3239 13.7816 13.1774 13.6351C13.0309 13.4886 12.8322 13.4062 12.625 13.4062Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_11637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMiniDocument);
export default __webpack_public_path__ + "static/media/ic_mini-document.1b29f1e0331d58d7047712c67ceda5d6.svg";
export { ForwardRef as ReactComponent };